import type { ReactNode } from 'react';

import { cn } from '@/shared/utils/cn';

type Tone = 'danger' | 'success' | 'info' | 'warning';

const TONES: Readonly<Record<Tone, string>> = {
  danger: 'bg-danger-subtle border-danger/40',
  success: 'bg-success-subtle border-success/40',
  info: 'bg-info-subtle border-info/40',
  warning: 'bg-warning-subtle border-warning/40',
};

interface AlertProps {
  tone: Tone;
  children: ReactNode;
  className?: string;
}

export function Alert({ tone, children, className }: AlertProps) {
  return (
    <div
      role={tone === 'danger' ? 'alert' : 'status'}
      className={cn('text-fg rounded-lg border p-4 text-sm', TONES[tone], className)}
    >
      {children}
    </div>
  );
}
